<div id="file-popup" class="content k-p-3">
  <section>
    <div class="k-d-flex k-align-items-center k-justify-content-between">
      <h4 class="k-my-0">Dateien</h4>
      <button
        kendoButton
        class="k-ml-22 !k-pr-4"
        themeColor="secondary"
        size="large"
        (click)="uploadFile()"
      >
        <fa-icon class="icon turquoise" size="xs" [icon]="faFileUpload"></fa-icon>
        Datei hochladen
      </button>
    </div>
  </section>

  <hr class="k-my-4" />

  <section>
    <ul class="k-list-none k-px-0 k-mb-0">
      @for (attachment of attachments(); track attachment.id) {
        <li class="k-mb-1">
          <fa-icon [icon]="faFileExcel" />
          <span class="k-ml-1 k-mr-1.5">{{ attachment.fileName }}</span>
          <a class="k-link">
            <fa-icon class="turquoise" [icon]="faDownload" (click)="downloadFile(attachment.id)" />
          </a>
        </li>
      }
    </ul>
  </section>
</div>
